(function () {
  if (customElements.get('subscription-card')) return;

  class SubscriptionCard extends HTMLElement {
    constructor() {
      super();
      this.ready = false;
    }

    connectedCallback() {
      this.querySelectorAll('[data-product-toggle]').forEach((el) => {
        el.addEventListener('change', this.onProductChange.bind(this));
      });
      this.querySelectorAll('input[data-purchase-type]').forEach((el) => {
        el.addEventListener('change', this.setPurchaseType.bind(this));
      });
      this.querySelectorAll('select[data-frequency-select]').forEach((el) => {
        el.addEventListener('change', this.onFrequencyChange.bind(this));
      });
      this.setProductId();
      this.ready = true;
      // Write the default selection into the hidden inputs at load. Without
      // this, an untouched card (Subscribe pre-selected, no change event)
      // submits an empty selling_plan and is added one-time.
      this.updateForm();
      // Capture-phase submit hook: re-sync hidden inputs right before
      // product-form.js (bubble-phase listener) reads them via FormData.
      const form = this.querySelector('form');
      if (form) {
        form.addEventListener(
          'submit',
          () => {
            this.setProductId();
            this.updateForm();
          },
          true
        );
      }
    }

    setProductId() {
      const checked = Array.from(this.querySelectorAll('input[data-product-toggle]')).find((r) => r.checked);
      if (checked) {
        this.productId = checked.value;
      } else {
        // Single-product card — no tabs. Derive from the first selector.
        const sel = this.querySelector('[data-product-selector]');
        this.productId = sel && sel.dataset.productId;
      }
      this.productSelector = this.querySelector(`[data-product-selector][data-product-id="${this.productId}"]`);
      this.setPurchaseType();
    }

    setPurchaseType() {
      if (!this.productSelector) return;
      const checked = Array.from(this.productSelector.querySelectorAll('input[data-purchase-type]')).find(
        (r) => r.checked
      );
      if (!checked) return;
      this.sellingPlanId = checked.dataset.sellingPlanId || '';
      this.price = checked.dataset.price || '';
      if (this.ready) this.updateForm();
    }

    updateForm() {
      const form = this.querySelector('form');
      if (!form) return;
      const idInput = form.querySelector('input[name="id"]');
      let planInput = form.querySelector('input[name="selling_plan"]');
      // buy-buttons only renders the selling_plan input when the product
      // has a selected selling plan. Inject one if missing.
      if (!planInput) {
        planInput = document.createElement('input');
        planInput.type = 'hidden';
        planInput.name = 'selling_plan';
        form.appendChild(planInput);
      }
      if (idInput) idInput.value = this.productId;
      planInput.value = this.sellingPlanId || '';
    }

    onFrequencyChange(e) {
      const select = e.target;
      const opt = select.options[select.selectedIndex];
      if (!opt) return;
      const targetId = select.dataset.targetSubscribe;
      const subRadio = this.querySelector('[id="' + targetId + '"]');
      if (!subRadio) return;
      subRadio.dataset.sellingPlanId = opt.dataset.sellingPlanId || opt.value || '';
      subRadio.dataset.price = opt.dataset.price || '';
      // Update the visible price inside the Subscribe label header.
      const label = this.querySelector('label[for="' + targetId + '"]');
      const priceDisplay = label && label.querySelector('[data-sub-price-display]');
      if (priceDisplay && opt.dataset.price) priceDisplay.innerHTML = opt.dataset.price;
      // Re-sync the hidden form input + ATC price.
      this.setPurchaseType();
    }

    onProductChange() {
      this.setProductId();
      this.querySelectorAll('[data-product-hero]').forEach((el) => el.classList.add('hidden'));
      this.querySelectorAll('[data-product-selector]').forEach((el) => el.classList.add('hidden'));
      this.querySelectorAll(`[data-product-hero][data-product-id="${this.productId}"]`).forEach((el) =>
        el.classList.remove('hidden')
      );
      if (this.productSelector) this.productSelector.classList.remove('hidden');
      this.updateForm();
    }
  }

  customElements.define('subscription-card', SubscriptionCard);
})();
